import styled from "@emotion/styled";
import {
  fontSize,
  spacing,
  borderRadius,
  shadow,
  zIndex,
  opacity,
  layout,
  lineHeight,
  duration,
  nav,
  surface,
  text,
  border,
  delayVisibility,
  inAndOutOpacity,
} from "@atlas-int/tokens";

export { delayVisibility, inAndOutOpacity };

export const OptionIcon = styled.div`
  width: ${spacing[16]};
  height: ${spacing[16]};
  text-align: center;
  padding: ${spacing[2]};
  display: flex;
  justify-content: center;
  align-items: center;

  & img {
    margin: auto;
    width: ${spacing[12]};
  }
`;

export const OptionLabel = styled.span`
  display: block;
  color: ${text.onDark};
  text-align: center;
  font-size: ${fontSize.xs};

  animation-name: ${delayVisibility};
  animation-duration: ${duration.fast};
  animation-delay: ${duration.fast};
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

export const OptionsListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0px ${spacing[4]};
  cursor: pointer;

  &.expanded {
    animation-name: ${inAndOutOpacity};
    animation-duration: ${duration.slow};
    animation-delay: 0s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &.closed {
    animation-name: ${inAndOutOpacity};
    animation-duration: ${duration.slow};
    animation-delay: 0s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &:hover > div {
    background-color: ${nav.surface};
    border-radius: ${borderRadius.lg};
  }
`;

export const disabledVizTooltipClassName = "disabledVizTooltip";
export const VizTypeList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px;
  margin: 0px;

  & a {
    text-decoration: none;
    color: inherit;
    display: block;
    width: fit-content;
  }
`;

export const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px;
  margin-top: auto;

  & a {
    text-decoration: none;
    color: inherit;
  }
`;

export const OptionsListRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${spacing[4]};

  &.expanded {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    animation-name: ${inAndOutOpacity};
    animation-duration: ${duration.slow};
    animation-delay: 0s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &.closed {
    flex-direction: column;
    align-items: center;
    animation-name: ${inAndOutOpacity};
    animation-duration: ${duration.slow};
    animation-delay: 0s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
`;

export const MenuRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${spacing[2]} 0px;
  width: calc(${layout.navBarExpandedWidth} - 45px);
  box-sizing: border-box;
  margin-right: ${spacing[2]};

  &:hover {
    background-color: ${nav.surface};
  }

  &.selected {
    background-color: ${nav.surface};
    box-shadow: ${shadow.sm};
  }

  &.disabledVisOption {
    cursor: not-allowed;
    opacity: ${opacity.muted};
  }

  &.disabledVisOption > * {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: none;
  }

  &.disabledVisOption:hover .${disabledVizTooltipClassName} {
    visibility: visible;
  }
`;

export const MenuRowIcon = styled.div`
  width: ${layout.navBarWidth};
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
`;

export const MenuHeaderGrowthLabIcon = styled(MenuRowIcon)`
  width: 100%;
  padding: ${spacing[4]} ${spacing[4]} 0px ${spacing[4]};
  margin: 0px;
  margin-left: ${spacing[2]};
  justify-content: flex-start;

  & img {
    max-width: 240px;
    height: auto;
  }

  &.collapsed {
    width: ${layout.navBarWidth};
    padding: ${spacing[4]} 0 0 0;
    margin-left: 0;
    justify-content: center;

    & img {
      max-width: 48px;
    }
  }

  &.fadeIn {
    animation: ${inAndOutOpacity} ${duration.slow} linear forwards;
  }
`;

export const MenuRowLabel = styled.p`
  flex: 1 0;
  color: ${text.onDark};
  font-size: ${fontSize.xs};
  margin: 0px;
  padding: ${spacing[2]} ${spacing[2]} ${spacing[2]} ${spacing[2]};

  & p {
    width: 100%;
  }
`;

export const OpenPanelArrowContainer = styled.button`
  /* Reset the browser's default button chrome so it matches the old <div>. */
  border: none;
  background: none;
  font: inherit;
  padding: 0;

  width: 100%;
  text-align: center;
  cursor: pointer;

  &.expanded {
    text-align: right;
    padding-right: ${spacing[2]};
  }

  &.closed {
    text-align: center;
    padding-right: 0px;
  }

  /* Mirror the hover highlight on keyboard focus. */
  &:focus-visible > div {
    background-color: ${nav.surface};
    border-radius: ${borderRadius.lg};
  }
`;

export const OpenPanelArrowButtonContainer = styled.div`
  display: inline-block;
  padding: ${spacing[4]};
  width: fit-contents;

  &:hover {
    background-color: ${nav.surface};
    border-radius: ${borderRadius.lg};
  }
`;

export const OpenPanelArrow = styled.div`
  border: solid ${text.onDark};
  border-width: 0 3px 3px 0;
  padding: ${spacing[2]};
  width: ${spacing[3]};
  height: ${spacing[3]};
  cursor: pointer;

  &.openArrow {
    transform: rotate(-45deg) translate(-2px, -2px);
    -webkit-transform: rotate(-45deg) translate(-2px, -2px);
  }

  &.closeArrow {
    transform: rotate(135deg) translate(-2px, -2px);
    -webkit-transform: rotate(135deg) translate(-2px, -2px);
  }
`;

export const countryProfilesUrlBase = "/countries";

export const NotAvailableTooltip = styled.div`
  position: fixed;
  left: calc(${layout.navBarWidth} + 6px);
  max-width: 220px;
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.normal};
  color: ${text.primary};
  background-color: ${surface.white};
  white-space: normal;
  padding: ${spacing[4]};
  box-sizing: border-box;
  z-index: ${zIndex.dropdown};
  border-radius: ${borderRadius.base};
  border: 1px solid ${border.subtle};
  box-shadow: ${shadow.sm};
  transform: translateY(-50%);
  cursor: default;

  &:after {
    content: "";
    position: absolute;
    top: calc(50% - 6px);
    left: -6px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid ${surface.white};
    filter: drop-shadow(-1px 0 1px rgba(0, 0, 0, 0.15));
  }
`;

export const DisabledVizTypeTooltipContainer = styled.div`
  margin: 0px;
  padding: 0px;
  width: ${layout.navBarExpandedWidth};
`;

// Re-export nav primitives from navStyles for ExploreNavigationBar
export {
  NavBarRoot as NavBar,
  NavGroupRoot as NavGroup,
  NavLinkRoot as NavLink,
} from "./navStyles";

export const ExternalLinkImage = styled.img`
  width: ${spacing[8]};
`;
